import { faCalendar } from '@fortawesome/pro-solid-svg-icons'
import clsx from 'clsx'
import type { MeetingApplicantEvent } from '~/domains/actions/types'
import {
  historyItemMeta,
  historyItemStatus,
  historyItemStatusCancelled,
  historyItemStatusCompleted,
  historyItemStatusNotCompleted
} from '../ApplicantHistory.css'
import { BaseHistoryCard } from './BaseHistoryCard'
import { HistoryItemContent } from './HistoryItemContent'

const getMeta = (event: MeetingApplicantEvent) => {
  if (event.isCancelled) {
    return (
      <span className={clsx(historyItemStatus, historyItemStatusCancelled)}>
        Annulé
      </span>
    )
  }

  if (event.isCompleted) {
    return (
      <span className={clsx(historyItemStatus, historyItemStatusCompleted)}>
        Abouti
      </span>
    )
  }

  if (event.isCompleted === false) {
    return (
      <span className={clsx(historyItemStatus, historyItemStatusNotCompleted)}>
        Non abouti
      </span>
    )
  }

  return null
}

export const MeetingHistoryCard = ({
  event
}: {
  event: MeetingApplicantEvent
}) => {
  const meta = getMeta(event)
  return (
    <BaseHistoryCard
      event={event}
      icon={faCalendar}
      title={
        <>
          {event.contacts && event.contacts.length > 0
            ? 'Rendez-vous contact'
            : 'Rendez-vous candidat'}
          {meta && <div className={historyItemMeta}>{meta}</div>}
        </>
      }
    >
      {event.notes && <HistoryItemContent>{event.notes}</HistoryItemContent>}
      {event.meetingLink && (
        <HistoryItemContent>
          <a href={event.meetingLink} target="_blank" rel="noopener noreferrer">
            Rejoindre la réunion
          </a>
        </HistoryItemContent>
      )}
    </BaseHistoryCard>
  )
}
